import { render, staticRenderFns } from "./Refundmoneyinfo.vue?vue&type=template&id=c84c1014&scoped=true&"
import script from "./Refundmoneyinfo.vue?vue&type=script&lang=js&"
export * from "./Refundmoneyinfo.vue?vue&type=script&lang=js&"
import style0 from "./Refundmoneyinfo.vue?vue&type=style&index=0&id=c84c1014&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84c1014",
  null
  
)

export default component.exports